'use client';

import { useTranslation } from 'react-i18next';

import { CLASSES_DA_FAIXA, FAIXAS_DA_LEGENDA } from '@/app/mapa/helpers/coresDaOcupacao';
import { cn } from '@/lib/utils';

/**
 * As quatro cores da faixa de semanas, numa linha só e com as MESMAS classes que ela
 * pinta: uma legenda que nomeia o seu próprio tom mente assim que um dos dois muda.
 *
 * É mais curta que a legenda do Mapa de propósito. A de lá explica os dois percentuais em
 * vigor e as semanas abertas no detalhe, e aqui não há detalhe para abrir nem espaço para
 * duas linhas de legenda num cartão que divide a tela com outros cinco.
 */
export function OcupacaoLegenda({ className }: { className?: string }) {
  const { t } = useTranslation('common');

  return (
    <ul className={cn('flex flex-wrap items-center gap-x-3 gap-y-1', className)}>
      {FAIXAS_DA_LEGENDA.map((faixa) => (
        <li key={faixa} className="flex items-center gap-1.5">
          <span className={cn('size-2.5 shrink-0 rounded-sm', CLASSES_DA_FAIXA[faixa].fundo)} aria-hidden />
          <span className="text-xs text-foreground-subtle">{t(`visaoExecutiva.capacidade.legenda.${faixa}`)}</span>
        </li>
      ))}
    </ul>
  );
}
